import { P3 } from '@src/components/Typography';
import { themeStyle } from '@src/theming';
import styled from 'styled-components';

import { ImageInputTheme } from './types';

export const Container = styled.div<{
  disabled?: boolean;
  $theme: ImageInputTheme;
}>`
  display: flex;
  flex-direction: column;

  background: ${themeStyle.varBackgroundBase};
  border: 1px dashed ${themeStyle.varInkLightMedium};
  border-radius: ${themeStyle.radiusMedium};
  height: ${({ $theme }) => $theme.height ?? 'initial'};
  min-height: ${({ $theme }) => $theme.minHeight ?? 'initial'};
  padding: 14px;
  gap: 16px;
  justify-content: center;
  box-sizing: border-box;
  max-width: ${({ $theme }) => $theme.maxWidth ?? 'initial'};
  position: relative;

  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};

  &.invalid {
    border-color: ${themeStyle.varAlertRed};
  }

  &:hover:not(.invalid),
  &.valid {
    border-color: ${({ disabled }) =>
      disabled ? undefined : themeStyle.varBlueMain};
  }
`;

export const ImageContainer = styled.div<{
  $theme: ImageInputTheme;
}>`
  display: flex;

  flex: 1;
  max-height: ${({ $theme }) => $theme.maxImageHeight ?? 'initial'};
  align-items: center;
  width: 100%;
  justify-content: center;
`;

export const Image = styled.img`
  max-width: 100%;
  max-height: 100%;
  height: fit-content;
  object-fit: contain;
  border-radius: ${themeStyle.radiusSmall};
  box-shadow: ${themeStyle.shadowSoft};
`;

export const TextContainer = styled.div`
  display: flex;

  justify-content: center;
  width: 100%;
  gap: 8px;
`;

export const Text = styled(P3)`
  font-weight: ${themeStyle.fontSemiBold};
  color: ${themeStyle.varInkMedium};

  span {
    text-decoration: underline;
    text-underline-position: under;
  }
`;

export const DragOverlay = styled.div`
  position: absolute;

  top: 0;
  left: 0;

  width: 100%;
  height: 100%;

  z-index: 2;
`;
